import { Stack, Typography } from "@mui/material";
import styles from "./ActionCard.module.css";

type ActionCardProps = {
	title: string;
	description: string;
	startIcon: React.ReactNode;
	rightButton: React.ReactNode;
};

export default function ActionCard({ title, description, startIcon, rightButton }: ActionCardProps) {
	return (
		<div className={styles.card}>
			<div className={styles.spaceBetween}>
				<Stack direction='row' spacing='12px' alignItems='center'>
					{startIcon}
					<Stack>
						<Typography className={styles.title}>{title}</Typography>
						<Typography className={styles.description}>{description}</Typography>
					</Stack>
				</Stack>
				{rightButton}
			</div>
		</div>
	);
}
